import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';

export interface TypedDialog<TDialog, TData, TReturn> {
  dialogRef: MatDialogRef<TDialog, TReturn>;
  data: TData;
}

@Injectable({
  providedIn: 'root',
})
export class DialogV2Service {
  constructor(private dialog: MatDialog) {}

  open<T extends TypedDialog<unknown, unknown, unknown>>(component: ComponentType<T>, config: Config<DialogData<T>>) {
    return this.dialog.open<T, DialogData<T>, DialogReturn<T>>(component, {
      ...config,
    });
  }
}

type Config<T> = MatDialogConfig<T> & { data: T };

type DialogReturn<T extends TypedDialog<unknown, unknown, unknown>> =
  T extends TypedDialog<unknown, unknown, infer TResult> ? TResult : never;

type DialogData<T extends TypedDialog<unknown, unknown, unknown>> = T extends TypedDialog<unknown, infer TData, unknown> ? TData : never;
